import React from 'react';
import { connect } from 'react-redux';
//import { Link } from 'react-router-dom';
// Store
import { IRootState } from '../../../redux';
import { Dispatch } from 'redux';
import { showSidebar, hideSidebar } from '../../../redux/sidebar/actions';
import { selectFolder } from '../../../redux/mailbox/actions';
// Styles
import styles from './sidebar.module.scss';
import images from '../../../assets/images/images';
// Config
import { ConfigContext } from '../../../providers';
// Helpers
import { isMediaSizeMD, isMediaSizeLessThanMD, isMediaSizeLessThanLG } from '../../../helpers/layout';
import { isTouchScreen } from '../../../helpers/browser';
// Components
//import StaticResource from '../../../components/StaticResource';
import { Image } from '../..';
// Interfaces
import { ISelectedFolder } from '../../../interfaces/folder.interfaces';

interface ISidebarProps {
    isEmpty?: boolean;
    children?: React.ReactNode;
}

interface ISidebarState {
    showClosingAnim: boolean;
}

class Sidebar extends React.Component<ReduxType, ISidebarState> {
    constructor(props: ReduxType) {
        super(props);
        this.state = {
            showClosingAnim: false,
        };
        Sidebar.contextType = ConfigContext;
    }

    componentDidUpdate(prevProps: ReduxType) {
        if (prevProps.sidebarShown !== this.props.sidebarShown) {
            if (!this.props.sidebarShown) {
                this.setState({ showClosingAnim: true });
                setTimeout(() => {
                    this.setState({ showClosingAnim: false });
                }, 400);
            }
        }
    }

    toggleSidebar = () => {
        this.props.sidebarShown ? this.props.hideSidebar() : this.props.showSidebar();
    };

    onLogoClick = (event: React.MouseEvent) => {
        if (this.props.sidebarShown) {
            this.props.hideSidebar();
        }

        this.props.selectFolder(null);
    };

    public render() {
        const isTouch = isTouchScreen();
        const isLessThanLG = isMediaSizeLessThanLG(this.props.mediaSize);
        const currentLocation = window.location.pathname;
        return (
            <aside
                className={[
                    styles.sidebar,
                    !isLessThanLG && isTouch ? styles.touchSidebar : '',
                    this.props.sidebarShown ? styles.opened : '',
                    isLessThanLG && this.state.showClosingAnim ? styles.closed : '',
                ].join(' ')}
            >
                {!this.props.isEmpty && (
                    <div
                        className={[
                            currentLocation.includes('/settings/profile')
                                ? styles.sidebarProfileInner
                                : styles.sidebarInner,
                            (isMediaSizeLessThanMD(this.props.mediaSize) ||
                                (isMediaSizeMD && this.props.sidebarShown)) &&
                                styles.floatingSidebarBorderColor,
                            'd-flex flex-column flex-fill h-100',
                        ].join(' ')}
                    >
                        <div
                            className={[
                                'w-100 pb-2 pt-4 d-none d-md-flex d-lg-none',
                                !this.props.sidebarShown ? 'justify-content-center' : 'justify-content-end pr-3',
                            ].join(' ')}
                        >
                            <Image
                                onClick={this.toggleSidebar}
                                src={!this.props.sidebarShown ? images.tabletShow : images.tabletHide}
                            />
                        </div>
                        {isLessThanLG && !this.props.sidebarShown && currentLocation.includes('/settings/profile')
                            ? null
                            : this.props.children}
                    </div>
                )}
            </aside>
        );
    }
}

const mapStateToProps = ({ sidebar, appReadouts, mailbox }: IRootState) => {
    return {
        sidebarShown: sidebar.sidebarShown,
        mediaSize: appReadouts.mediaSize,
    };
};

const mapDispatcherToProps = (dispatch: Dispatch) => {
    return {
        showSidebar: () => dispatch(showSidebar()),
        hideSidebar: () => dispatch(hideSidebar()),
        selectFolder: (folder: ISelectedFolder) => dispatch(selectFolder(folder)),
    };
};

type ReduxType = ISidebarProps & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatcherToProps>;
export default connect(mapStateToProps, mapDispatcherToProps)(Sidebar);
